import styled, { css } from "styled-components";
import { Button } from "../Button";
import { getPropertyByMedia, getThemeMedia, getThemeSpace } from "../helpers";
export const CounterContainer = styled.div `
	display: flex;
	gap: ${getThemeSpace("4")};
	align-items: center;
	justify-content: space-between;

	border: 1px solid var(--border-primary);
	border-radius: 4px;
	background: var(--surface-white);
	padding: 0;

	${({ width }) => getPropertyByMedia("width", width, "max-content")}
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth, "initial")}
	height: 48px;

	${({ disabled }) => disabled &&
    css `
			opacity: 0.5;

			& > button {
				cursor: not-allowed;
				opacity: 0.5 !important;
			}
		`}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			gap: ${getThemeSpace("4")};
		}
	}

	${({ hasPermission }) => !hasPermission &&
    css `
			/* pointer-events: none; */
			cursor: not-allowed;
		`}
`;
export const CounterButton = styled(Button) `
	padding: 0;

	width: 26px;
	height: 40px;

	cursor: pointer;
	transition: all 100ms ease-in;

	&:hover,
	&:active {
		svg {
			fill: var(--neutral-black);
		}
	}

	&:first-child {
		padding-right: 0;
	}

	&:last-child {
		padding-left: 0;
	}

	&:disabled {
		opacity: 0.5;
	}

	&[data-testid='add'] {
		padding-right: 8px;
	}

	&[data-testid='remove'] {
		padding-left: 8px;
	}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			padding: 0 ${getThemeSpace("8")};
		}
	}
`;
export const CounterDisplay = styled.input `
	border: 0;
	background: transparent;
	font-weight: 400;

	width: 100%;
	max-width: 60px;

	text-align: center;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	&[type='number'] {
		-moz-appearance: textfield;
	}
`;
//# sourceMappingURL=styles.js.map